import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { AnalysisResponse } from '@app/models/analysis.model';

interface Attachment {
    name: string;
    icon: string; // svgIcon name
    id: string;
    variant?: string;
    color: 'error' | 'success' | 'warning';
    reason?: string;
}

@Component({
    selector: 'app-attachments',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatTooltipModule],
    templateUrl: './attachments.component.html',
    styleUrls: ['./attachments.component.scss'],
})
export class AttachmentsComponent implements OnInit {
    @Input() analysis!: AnalysisResponse;
    attachments: Attachment[] = [];

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {
        this.matIconRegistry.addSvgIcon(
            'thumbs_up_custom',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/thumbs_up_icon.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'document_partially_unprocessed',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '/assets/icons/document_partially_unprocessed.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'attention',
            this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/attention.svg')
        );
    }

    ngOnInit(): void {
        this.rebuildAttachments();
    }

    private rebuildAttachments(): void {
        this.attachments = [];

        const hasIncompleteAspects = !this.analysis.areAllValidFactorsComplete();

        // Your requested rule:
        // If there are any incomplete, then we shouldn't show the thumbs up
        const shouldUseAttentionForNonIssueFiles = hasIncompleteAspects;
        console.log(
            'should use attention for non issue files: ' + shouldUseAttentionForNonIssueFiles
        );

        this.analysis.artifactInfos.forEach(artifact => {
            const notice = this.analysis.notices.find(
                n => n.artifactExternalId === artifact.externalId
            );

            if (notice) {
                this.attachments.push({
                    id: artifact.id,
                    name: artifact.externalFileId,
                    icon: 'document_partially_unprocessed',
                    variant: 'round',
                    color: 'error',
                    reason: notice.message,
                });
                return;
            }

            this.attachments.push({
                id: artifact.id,
                name: artifact.externalFileId,
                icon: shouldUseAttentionForNonIssueFiles ? 'attention' : 'thumbs_up_custom',
                color: shouldUseAttentionForNonIssueFiles ? 'warning' : 'success',
            });
        });
    }
}
